<!--多会场面板-->
<template>
  <div :class="[isPc ? 'branch-meet-contain-pc' : 'branch-meet-contain']">
    <div v-if="dateList.length > 0" class="contain-p">
      <div class="meet-date-list" :class="{ 'beauty-scroll': isPc }">
        <div
          v-for="(item, index) in dateList"
          :key="index"
          :class="['meet-date-item', selectedDate == item ? 'active' : '']"
          @click="changeDate(item)"
        >
          <div class="date-month">{{item.substring(5, 7)}}月</div>
          <div class="date-day">{{item.substring(8, 10)}}日</div>
        </div>
      </div>
      <div class="meet-content">
        <div class="meet-content-type" :class="{ 'beauty-scroll': isPc }">
          <div v-for="item in addressList" :key="item.id" :class="[item.id == selectedAddr ? 'type-live' : 'type-meet']" @click="changeAddr(item)">{{ item.address }}</div>
        </div>
        <div class="meet-content-contain" :class="{ 'beauty-scroll': isPc }">
          <normalList ref="normalList">
            <div v-for="item in list" :key="item.id" class="content-item-panel" @click="meetClick(item)">
              <div class="content-item">
                <div class="content-title">
                  <van-image
                    :width="isPc?'0.21rem':'0.2rem'"
                    :height="isPc?'0.27rem':'0.23rem'"
                    :src="require('@/assets/imgs/branch.png')"
                  />
                  <div class="title-value">{{ item.title }}</div>
                </div>
                <div class="content-time">
                  <van-image
                    :width="isPc?'0.21rem':'0.2rem'"
                    :height="isPc?'0.21rem':'0.2rem'"
                    :src="require('@/assets/imgs/time.png')"
                  />
                  <div class="time-value">{{ item.begin_time.slice(-8,-3) }}～{{ item.end_time.slice(-8,-3) }}</div>
                  <div v-if="item.is_open_scope" class="credit-icon">付费</div>
                </div>
                <div class="content-rooms" :style="{ paddingBottom: (item.academic_list||[]).length == 0 ? '0.26rem' : '0'}">
                  <div v-for="academic in item.academic_list" :key="academic.id" class="room-item">
                    <div class="room-avatar">
                      <van-image
                        :width="isPc?'0.73rem':'0.61rem'"
                        :height="isPc?'0.73rem':'0.61rem'"
                        round
                        :src="academic.expert ? academic.expert.headimg : null"
                        :loading-icon="'manager-o'"
                        error-icon="manager-o"
                      />
                    </div>
                    <div class="room-desc">
                      <div class="room-name">{{ academic.title }}</div>
                      <div class="room-time-p">
                        <div class="room-time">{{ academic.begin_time.slice(-8,-3) }}～{{ academic.end_time.slice(-8,-3) }}</div>
                        <div :class="[ academic.live_status == 'ONGOING' ? 'room-status-living' : 'room-status-pending']">
                          <van-image
                            :width="isPc?'0.22rem':'0.18rem'"
                            :height="isPc?'0.19rem':'0.15rem'"
                            :src="academic.live_status == 'ONGOING' ? (isCurrentLive(item) ? require('@/assets/imgs/live-curr.gif') : require('@/assets/imgs/live-other.gif')) : require('@/assets/imgs/live-other.png')"
                          />
                          <div :class="['room-status-text', isCurrentLive(item) ? 'status-text-curr' : 'status-text-other']">{{ academic.live_status == 'ONGOING' ? '直播中' : '未开始' }}</div>
                        </div>
                      </div>
                      <div class="room-member">
                        <div class="room-member-name">{{ academic.expert ? academic.expert.name : null }}</div>
                        <div class="room-member-hospital">{{ academic.expert ? academic.expert.hospital : null  }}</div>
                      </div>
                    </div>
                    <!-- <div class="room-btn">
                      <van-button type="info">进入</van-button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </normalList>
        </div>
      </div>
    </div>
    <div v-else class="nodata-p">暂无数据</div>
  </div>
</template>

<script>
import { getConventionSites, getConventionSchedulesDetail } from '@/models/common'
import listMixin from '@/components/normalListView/index.js'
import { mapState } from 'vuex'
import { getQueryObject } from '@/utils/util.js'
export default {
  mixins: [listMixin],
  props: {
    dateList: {
      type: Array,
      default: () => []
    },
    conventionId: {
      type: Number,
      default: -1
    },
    defaultDate: {
      type: String,
      default: ''
    },
    defaultSite: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedDate: '',
      addressList: [], // 会场地址
      selectedAddr: '', // 选中的会场地址
    }
  },
  watch: {
    'dateList': function(val) {
      if(val.length > 0) {
        if (this.defaultDate != '' && val.includes(this.defaultDate)) {
          // 日期初始化时，如果传入默认日期且默认日期在日期列表内，则优先查询默认日期的分会场
          this.changeDate(this.defaultDate, this.defaultSite)
        } else {
          this.changeDate(val[0])
        }
      }
    }
  },
  computed: {
    ...mapState(['isPc', 'content']),
    isCurrentLive() {
      // 当前多会场的会场是否是当前直播间
      return (item) => {
        if (item) {
          return this.$route.query.room == item.live_stream_id
        } else {
          return false
        }
      }
    }
  },
  methods: {
    // 选择分会场日期
    changeDate(date, defaultSite = '') {
      this.selectedDate = date
      getConventionSites({
        id: this.conventionId,
        date
      }).then(res => {
        if (res.data.code == 0) {
          this.addressList = res.data.data
        }else {
          this.addressList = []
        }
        if(this.addressList.length > 0) {
          if(defaultSite != '') {
            // 如果有默认站点，则优先展示默认站点
            const index = this.addressList.findIndex(item => item.id == defaultSite)
            if(index > -1) {
              this.changeAddr(this.addressList[index])
            }else {
              this.changeAddr(this.addressList[0])
            }
          }else {
            this.changeAddr(this.addressList[0])
          }
        } else {
          this.callback()
        }
      })
    },
    // 选择分场地
    changeAddr(addr) {
      this.selectedAddr = addr.id
      // this.init(this.callback)
      try{
        this.$refs.normalList.refresh()
        // 可能触发的时候normalList还没初始化完成，此时手动调取一次init
      } catch(e) {
        this.page = 1
        this.list = []
        this.init(this.callback)
      }
    },
    init(callback) {
      if(this.selectedDate == '' && this.dateList.lenght > 0) {
        this.selectedDate = this.dateList[0]
      }
      const _this = this
      getConventionSchedulesDetail({
        id: this.conventionId,
        site_id: this.selectedAddr,
        date: this.selectedDate,
        page_no: this.page - 1, // vant从page=1开始，接口从0开始
        page_size: this.pageSize
      }).then(res => {
        if (res.data.code == 0) {
          _this.list = _this.list.concat(res.data.data.rows)
          _this.totalPage = res.data.data.count
        }
        callback()
      })
    },
    // 会场跳转
    meetClick(item) {
      // 房间需要缴费但未缴费，提示没有权限，否则直接跳转
      if(item.is_open_scope && !item.is_credit_record) {
        this.$toast(this.content.hasNoLink)
      } else {
        if(item.live_url) {
          // 这里url不能直接跳转，否则不会触发hashchange及生命周期，判断如果是内部跳转则解析参数，重定向到auth，否则跳转给定链接
          if(item.live_url.indexOf('chat-online') > 0 || item.live_url.indexOf('auth') > 0) {
            const query = getQueryObject(item.live_url)
            this.$router.push({
              path: '/auth',
              query: {
                ...query,
                siteId: item.site_id
              }
            })
          }else {
            window.open(item.live_url)
          }
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.branch-meet-contain-pc {
  height: 100%;
  box-sizing: border-box;
  .contain-p{
    width: 100%;
    height: 100%;
  }
  .nodata-p{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
    font-size: 0.18667rem;
    height: 40%;
  }
  .meet-date-list {
    width: calc(100% - 0.78rem);
    height: 0.9rem;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.4rem 0.39rem 0.27rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #222328;
    .meet-date-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      .date-month{
        border-top: 1px solid #47A5E5;
        border-left: 1px solid #47A5E5;
        border-right: 1px solid #47A5E5;
        color: #3F97DD;
        font-size: 0.2rem;
        width: 1.0rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
      }
      .date-day{
        border: 1px solid #47A5E5;
        color: #3F97DD;
        font-size: 0.2rem;
        width: 1.0rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
      }
    }
    .meet-date-item+.meet-date-item{
      margin-left: 0.27rem;
    }
    .active {
      .date-day{
        background-color: #4BA3D9;
        color: #FFF;
      }
    }
  }
  .meet-content{
    height: calc(100% - 0.9rem - 0.67rem - 0.34rem);
    overflow-y: hidden;
    padding: 0.17rem 0.3rem 0.17rem 0.39rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: #222328;
    .meet-content-type{
      width: 1.27rem;
      height: 100%;
      overflow: hidden auto;
      .type-live{
        width: 1.07rem;
        height: 1.21rem;
        background-color: #4BA3D9;
        color: #FFF;
        font-size: 0.19rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.27rem;
        cursor: pointer;
      }
      .type-meet{
        width: 1.07rem;
        height: 1.21rem;
        border: 1px solid #4BA3D9;
        background-color: #222328;
        color: #4BA3D9;
        font-size: 0.19rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.27rem;
        cursor: pointer;
      }
    }
    .meet-content-contain{
      margin-left: 0.07rem;
      flex: 1;
      height: 100%;
      padding-right: 0.09rem;
      .content-item-panel{
        background-color: #4BA3D9;
        padding: 0.05rem 1px 1px;
        border-top-left-radius: 0.05rem;
        border-top-right-radius: 0.05rem;
        margin-bottom: 0.27rem;
        cursor: pointer;
        .content-item{
          background-color: #222328;
          height: 100%;
          padding: 0.19rem 0.19rem 0;
          .content-title{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .title-value{
              color: #FFF;
              font-size: 0.21rem;
              margin-left: 0.19rem;
              font-weight: bold;
              flex: 1;
            }
          }
          .content-time{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.17rem;
            .time-value{
              color: #747474;
              font-size: 0.19rem;
              margin-left: 0.19rem;
            }
            .credit-icon{
              color: #FFF;
              font-size: 0.19rem;
              margin-left: 0.14rem;
              background-color: #FF5000;
              padding: 0.04rem 0.08rem;
            }
          }
          .content-rooms{
            .room-item{
              padding: 0.26rem 0;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .room-avatar{
                display: flex;
              }
              .room-desc{
                margin-left: 0.13rem;
                flex: 1;
                .room-name{
                  font-size: 0.14rem;
                  color: #FFF;
                  margin-bottom: 0.1rem;
                }
                .room-time-p{
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  margin-bottom: 0.13rem;
                  .room-time{
                    font-size: 0.14rem;
                    color: #747474;
                  }
                  .room-status-living{
                    font-size: 0.14rem;
                    margin-left: 0.14rem;
                    display: flex;
                    align-items: center;
                    .room-status-text{
                      margin-left: 0.1rem;
                    }
                    .status-text-curr{
                      color: #4BA3D9;
                    }
                    .status-text-other{
                      color: #747474;
                    }
                  }
                  .room-status-pending{
                    font-size: 0.14rem;
                    color: #FF9600;
                    margin-left: 0.14rem;
                    display: flex;
                    align-items: center;
                    .room-status-text{
                      margin-left: 0.1rem;
                    }
                  }
                }
                .room-member{
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  .room-member-name{
                    font-size: 0.14rem;
                    color: #747474;
                  }
                  .room-member-hospital{
                    font-size: 0.14rem;
                    color: #747474;
                    margin-left: 0.2rem;
                    flex: 1;
                  }
                }
              }
              .room-btn{
                padding-top: 0.11rem;
                display: flex;
                /deep/.van-button {
                  width: 0.77rem;
                  height: 0.39rem;
                  font-size: 0.17rem;
                  color:#FFF;
                  padding: 0;
                  background-color: #0097E3;
                  border-color: #0097E3;
                  border-radius: 0.08rem;
                }
              }
            }
            .room-item+.room-item{
              border-top: 1px solid #747474;
            }
          }
        }
      }
    }
  }
}
.branch-meet-contain {
  height: 100%;
  box-sizing: border-box;
  .contain-p{
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  .nodata-p{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
    font-size: 0.18667rem;
    height: 40%;
  }
  .meet-date-list {
    width: calc(100% - 0.46rem);
    height: 0.6rem;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.17rem 0.23rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #FFF;
    .meet-date-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .date-month{
        border-top: 1px solid #05A6EB;
        border-left: 1px solid #05A6EB;
        border-right: 1px solid #05A6EB;
        color: #0097E3;
        font-size: 0.14rem;
        width: 0.71rem;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
      }
      .date-day{
        border: 1px solid #05A6EB;
        color: #0097E3;
        font-size: 0.14rem;
        width: 0.71rem;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
      }
    }
    .meet-date-item+.meet-date-item{
      margin-left: 0.13rem;
    }
    .active {
      .date-day{
        background-color: #1BA4DE;
        color: #FFF;
      }
    }
  }
  .meet-content{
    // height: calc(100% - 0.6rem - 0.34rem - 0.34rem);
    // overflow-y: hidden;
    padding: 0.17rem 0.23rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: #F6F9FF;
    .meet-content-type{
      width: 0.83rem;
      height: 100%;
      padding-right: 0.1rem;
      overflow: hidden auto;
      .type-live{
        width: 0.83rem;
        height: 1.21rem;
        background-color: #1BA4DE;
        color: #FFF;
        font-size: 0.19rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.16rem;
      }
      .type-meet{
        width: 0.83rem;
        height: 1.21rem;
        border-color: #1BA4DE;
        background-color: #FFF;
        color: #1BA4DE;
        font-size: 0.19rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.16rem;
      }
    }
    .meet-content-contain{
      margin-left: 0.06rem;
      flex: 1;
      height: 100%;
      overflow-y: auto;
      .content-item-panel{
        background-color: #1BA4DE;
        padding-top: 0.05rem;
        border-top-left-radius: 0.05rem;
        border-top-right-radius: 0.05rem;
        margin-bottom: 0.16rem;
        .content-item{
          background-color: #FFF;
          height: 100%;
          padding: 0.15rem 0.15rem 0;
          .content-title{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .title-value{
              color: #333;
              font-size: 0.19rem;
              margin-left: 0.15rem;
              font-weight: bold;
            }
          }
          .content-time{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.12rem;
            .time-value{
              color: #9B9B9B;
              font-size: 0.14rem;
              margin-left: 0.15rem;
            }
            .credit-icon{
              color: #FFF;
              font-size: 0.14rem;
              margin-left: 0.14rem;
              background-color: #FF5000;
              padding: 0.04rem 0.08rem;
            }
          }
          .content-rooms{
            .room-item{
              padding: 0.16rem 0;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .room-avatar{
                display: flex;
              }
              .room-desc{
                margin-left: 0.15rem;
                // margin-right: 0.15rem;
                flex: 1;
                .room-name{
                  font-size: 0.14rem;
                  color: #333333;
                  margin-bottom: 0.1rem;
                }
                .room-time-p{
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  margin-bottom: 0.1rem;
                  .room-time{
                    font-size: 0.14rem;
                    color: #9B9B9B;
                  }
                  .room-status-living{
                    font-size: 0.14rem;
                    margin-left: 0.14rem;
                    display: flex;
                    align-items: center;
                    .room-status-text{
                      margin-left: 0.06rem;
                    }
                    .status-text-curr{
                      color: #4BA3D9;
                    }
                    .status-text-other{
                      color: #747474;
                    }
                  }
                  .room-status-pending{
                    font-size: 0.14rem;
                    color: #FF9600;
                    margin-left: 0.14rem;
                    display: flex;
                    align-items: center;
                    .room-status-text{
                      margin-left: 0.06rem;
                    }
                  }
                }
                .room-member{
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  .room-member-name{
                    font-size: 0.14rem;
                    color: #9B9B9B;
                  }
                  .room-member-hospital{
                    font-size: 0.14rem;
                    color: #9B9B9B;
                    margin-left: 0.2rem;
                    flex: 1;
                  }
                }
              }
              .room-btn{
                padding-top: 0.15rem;
                /deep/.van-button {
                  width: 0.63rem;
                  height: 0.31rem;
                  font-size: 0.14rem;
                  color:#FFF;
                  padding: 0;
                  background-color: #0097E3;
                  border-color: #0097E3;
                  border-radius: 0.08rem;
                }
              }
            }
            .room-item+.room-item{
              border-top: 1px solid #EEEFF2;
            }
          }
        }
      }
    }
  }
}
</style>
